import { Link, useParams } from "react-router-dom";
import { quizRegistry } from "@quizzes/_registry";
import { isStoryFunnel } from "@quizzes/_schema";
import { StoryFunnelAnalytics } from "../components/StoryFunnelAnalytics";

export function StoryAnalytics() {
  const { slug = "" } = useParams();
  const story = quizRegistry[slug];
  if (!story || !isStoryFunnel(story)) return <p>Unknown story. <Link to="/quizzes" className="text-mars-orange underline">Back to list</Link></p>;
  return <StoryFunnelAnalytics key={story.slug} story={story} />;
}
